<template lang="pug">
    b.theme-cover(:data-theme='theme', :class='{bottom: bottom}', v-observe-visibility='{callback: catchThemeElement, intersection: {threshold: 0.9}}')
</template>

<script>
export default {
    name: 'BlockVisibilityTrigger',

    props: {
        theme: {
            default: 'white',
            type: String
        },
        bottom: {
            default: false,
            type: Boolean
        }
    },

    watch: {},

    methods: {
        catchThemeElement(e, el) {
            if (e) {
                this.$store.dispatch('setTheme', el.target.dataset.theme);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.theme-cover {
    position: absolute;
    display: inline-block;
    height: 99vh;
    width: 10px;
    top: 0;
    pointer-events: none;

    &.bottom {
        top: unset;
        bottom: 0;
        height: 10vh;
    }
}
</style>
